import request from "@/utils/request";

// 企业账户余额查询
export function getCompanyMoneyByCategory(query) {
  return request({
    url: "/ntocc-tms-api/platform/getCompanyMoneyByCategory",
    method: "get",
    params: query
  });
}

// 企业储值，返点记录查询
export function getMaLog(query) {
  // 开始结束时间不能超过90天
  return request({
    url: "/ntocc-tms-api/platform/getMaLog",
    method: "get",
    params: query
  });
}

// 获取司机余额
export function getBackMoney(query) {
  return request({
    url: "/ntocc-tms-api/userOil/byUsernameGetBackMoney",
    method: "get",
    params: query // userName
  });
}

// 司机开户储值
export function createUserAndStored(data) {
  return request({
    url: "/ntocc-tms-api/userOil/createUserAndStored",
    method: "post",
    data
  });
}

// 司机账户消费记录查询
export function getOrderRecord(data) {
  return request({
    url: "/ntocc-tms-api/userOil/getOrderRecord",
    method: "get",
    params: data
  });
}

// 回收司机余额
export function recoveryBackMoney(data) {
  return request({
    url: "/ntocc-tms-api/platform/recoveryBackMoney",
    method: "post",
    params: data
  });
}
// 撤销待领取金额
export function cancelRecharge(data) {
  return request({
    url: "/ntocc-tms-api/platform/cancelRecharge",
    method: "post",
    params: data
  });
}

// 拉取企业储值最新数据
export function updateMaLog() {
  return request({
    url: "/ntocc-tms-api/platform/updateMaLog",
    method: "get"
  });
}
// 授权企业账户列表及余额查询
export function getAuthorizeCompany(data) {
  return request({
    url: "/ntocc-tms-api/platform/getAuthorizeCompany",
    method: "post",
    params: data
  });
}

// 司机账户消费记录拉取数据
export function updateOrderRecord() {
  return request({
    url: "/ntocc-tms-api/userOil/updateOrderRecord",
    method: "get"
  });
}

// 是否需要财务支付
export function needFinancePay(query) {
  return request({
    url: "/ntocc-tps-api/oil/shipment/needFinancePay",
    method: "get",
    params: query
  });
}

// 配油前校验余额
export function preApplicationForOilFee(query) {
  return request({
    url: "/ntocc-tps-api/oil/shipment/preApplicationForOilFee",
    method: "post",
    data: query
  });
}

// 配置油费
export function configOilFee(query) {
  return request({
    url: "/ntocc-tps-api/oil/shipment/configOilFee",
    method: "post",
    data: query
  });
}

// 财务确认配油
export function batchPaymentOilFeeFinance(query) {
  return request({
    url: "/ntocc-tms-api/oilFeeFinance/batchPayment",
    method: "post",
    data: query
  });
}

// 未配置油费运单列表
// export function unconfiguredOilFeeList(query) {
//   return request({
//     url: "/ntocc-tps-api/oil/shipment/unconfiguredOilFeeList",
//     method: "get",
//     params: query
//   });
// }

// 财务油费支付列表
export function unconfiguredOilFeeList(query) {
  return request({
    url: "/ntocc-tps-api/oil/shipment/waitFinancePayList",
    method: "get",
    params: query
  });
}
